export default __webpack_public_path__ + "locales/it/PrivacyPage.json?hash=dad48bb6f96ac0a4e7fe5dee3b8455ac";